import Vue from "vue";
import DirectoryManager from "./DirectoryManager.vue";
import AsdInsurances from "./AsdInsurances.vue";
import MaterializecssModal from "../MaterializecssModal.vue";
import AsdInsurance from "./AsdInsurance.vue";
import Select2 from 'v-select2-component';

export default class Insurances {

    static init() {
        let elements = document.querySelectorAll('.asd-insurances');
        elements.forEach( x => {
            let rawData = x.getAttribute('data-insurances','');
            if (rawData === '') {
                console.log('Cannot instantiate: empty data', x);
                return;
            }

            let data;
            try {
                data = JSON.parse(rawData);
            }
            catch (e) {
                console.log('Cannot parse data', rawData, x);
                return;
            }

            let group_id = x.getAttribute('data-group');
            if (parseInt(group_id) <= 0) {
                console.log('Cannot instantiate: no group id', x);
                return;
            }

            let permissionValidation = parseInt(x.getAttribute('data-validation-permission'));

            Vue.component('DirectoryManager', DirectoryManager);
            Vue.component('AsdInsurance', AsdInsurance);
            Vue.component('MaterializecssModal', MaterializecssModal);
            Vue.component('Select2', Select2);

            let component = Vue.extend(AsdInsurances);
            new component({
                el: x,
                propsData: {
                    insurances: data,
                    group_id: parseInt(group_id),
                    validation: permissionValidation
                },
            });

        })
    }
}
